"use client";

import { useEffect, useRef, useState } from "react";

export function SiteSafeImage({
  alt = "",
  className,
  src,
  unavailableLabel
}: Readonly<{ alt?: string; className?: string; src: string; unavailableLabel: string }>) {
  const [failed, setFailed] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const image = imageRef.current;
    if (image?.complete && image.naturalWidth === 0) setFailed(true);
  }, [src]);

  if (!src || failed) return <span className={className} role="status">{unavailableLabel}</span>;
  return <img alt={alt} className={className} onError={() => setFailed(true)} ref={imageRef} src={src} />;
}
